export const MATERIALS = {
  CAST_IRON: 0,
  STEEL: 1,
  DUCTILE_IRON: 2,
  ASBESTOS_CEMENT: 3,
  PLASTIC: 4,
  CONCRETE: 5,
  UNKNOWN: 6,
  OTHER: 7,
  PVC: 8,
  PEHDPE: 9,
  PCRC: 10
} as const

export type MaterialKey = keyof typeof MATERIALS

// Reverse mapping: number -> material key
export const MATERIAL_CODE_TO_KEY: Record<number, string> = {
  0: 'CAST_IRON',
  1: 'STEEL',
  2: 'DUCTILE_IRON',
  3: 'ASBESTOS_CEMENT',
  4: 'PLASTIC',
  5: 'CONCRETE',
  6: 'UNKNOWN',
  7: 'OTHER',
  8: 'PVC',
  9: 'PEHDPE',
  10: 'PCRC'
}

export const MATERIAL_KEY_TO_CODE: Record<MaterialKey, number> = {
  ASBESTOS_CEMENT: MATERIALS.ASBESTOS_CEMENT,
  CAST_IRON: MATERIALS.CAST_IRON,
  CONCRETE: MATERIALS.CONCRETE,
  DUCTILE_IRON: MATERIALS.DUCTILE_IRON,
  OTHER: MATERIALS.OTHER,
  PCRC: MATERIALS.PCRC,
  PEHDPE: MATERIALS.PEHDPE,
  PLASTIC: MATERIALS.PLASTIC,
  PVC: MATERIALS.PVC,
  STEEL: MATERIALS.STEEL,
  UNKNOWN: MATERIALS.UNKNOWN
}

export const MATERIAL_ALIAS_TO_KEY: Record<string, MaterialKey> = {
  AC: 'ASBESTOS_CEMENT',
  ASBESTOSCEMENT: 'ASBESTOS_CEMENT',
  CAS: 'CAST_IRON',
  CASTIRON: 'CAST_IRON',
  CI: 'CAST_IRON',
  CON: 'CONCRETE',
  CONCRETE: 'CONCRETE',
  DIP: 'DUCTILE_IRON',
  DUCTILEIRON: 'DUCTILE_IRON',
  FER: 'DUCTILE_IRON',
  GH: 'CAST_IRON',
  OTH: 'OTHER',
  OTHER: 'OTHER',
  PCRC: 'PCRC',
  PE: 'PEHDPE',
  PEHDPE: 'PEHDPE',
  PL: 'PLASTIC',
  PLASTIC: 'PLASTIC',
  PVC: 'PVC',
  RC: 'PCRC',
  SCO: 'UNKNOWN',
  SP: 'STEEL',
  STEEL: 'STEEL',
  ST: 'STEEL',
  UNK: 'UNKNOWN',
  UNKNOWN: 'UNKNOWN'
}

export const PROPORTION_MATERIAL_KEYS = [
  'CAS',
  'SP',
  'DIP',
  'AC',
  'PLASTIC',
  'CON',
  'OTH',
  'UNK',
  'PVC',
  'PEHDPE',
  'PCRC'
] as const

/**
 * Dolphin's canonical internal material names, the spelling stored in
 * `api_customcofentity.materials`. Looks like `PROPORTION_MATERIAL_KEYS`, but that array orders
 * `OTH`/`UNK` by tile column name rather than by material code; `constants.materialAbbr` is a
 * different thing again, localized display text.
 */
export const MATERIAL_KEY_TO_DOLPHIN_NAME: Record<MaterialKey, string> = {
  CAST_IRON: 'CAS',
  STEEL: 'SP',
  DUCTILE_IRON: 'DIP',
  ASBESTOS_CEMENT: 'AC',
  PLASTIC: 'PLASTIC',
  CONCRETE: 'CON',
  UNKNOWN: 'UNK',
  OTHER: 'OTH',
  PVC: 'PVC',
  PEHDPE: 'PEHDPE',
  PCRC: 'PCRC'
}
